export default __webpack_public_path__ + "static/media/boltWhite.be72de46.svg";